import React, { useState } from 'react';
import PageHeader from '../../../shared/components/PageHeader';
import Flag from 'react-world-flags'
import RelocationConvention from '../../../shared/components/RelocationConvention';
import { Space, Spin } from 'antd';
import queryString from 'query-string';
import useRelocation from '../../../utils/hooks/useRelocation';
import LocaleSwitcher from '../../../shared/LocaleSwitcher';

const PublicRelocationShow = props => {
  const {
    token: relocationToken
  } = props.match.params;
  const { record: relocation, loading } = useRelocation(relocationToken, { fetch: true });

  if (!loading && !relocation?.id)
    window.location.href = "/404"

  if(!relocation || loading)
    return (
      <div style={{ textAlign: 'center', paddingTop: 32 }}>
        <Spin />
      </div>
    );

  const parsedHash = queryString.parse(location.search);
  const locale = parsedHash.locale || 'fr'
  const onLocaleChange = (locale) => {
    window.location.href = `${window.location.origin}${window.location.pathname}?locale=${locale}`
  }

  return (
    <>
      <PageHeader
        extra={[<LocaleSwitcher onChange={onLocaleChange} value={locale} />]}
        title={(
          <Space>
            <span>
              {relocation.uniqueIdentifier}
            </span>
            {relocation.countryIso && (
              <div className='flex-centered'>
                <Flag code={ relocation.countryIso } style={{ width: 25 }} />
              </div>
            )}
          </Space>
        )}
      />
      <div className="inner-body" style={{ paddingBottom: 15 }}>
        <RelocationConvention
          relocationId={relocationToken}
          showRelocationPeriodsForm={false}
          //readOnly
        />
      </div>
    </>
  )
}

export default PublicRelocationShow;